import { trackEvent } from '@/utils/omega';
import url from '@/utils/url';

type MethodType = 'GET' | 'POST' | 'PUT' | 'DELETE' | 'HEAD' | 'OPTIONS' | 'PATCH';
type Method = { config: { params: Record<string, any> }; data?: any; url: string; type: MethodType; meta?: { timeStart: number } };
type Responce = {
    status: number;
    statusText: string;
    json: () => Promise<any>;
};
type Data = { errno?: any; errorCode?: any; errmsg?: any; errorMsg?: any; traceId?: string };

export const getCommonTrackData = (method: Method) => {
    const { url: methodUrl, config } = method;

    let requsetUrl = '';

    try {
        const url = new URL(methodUrl);

        requsetUrl = url.pathname;
    } catch (e) {
        requsetUrl = methodUrl;
    }

    let formData = new FormData();
    let objectValue = {};

    if (method.data instanceof FormData) {
        formData = method.data;
        objectValue = Object.fromEntries(formData.entries());
    }

    return {
        pub_uid: url.get('uid'),
        pub_page: window.location.href,
        pub_country: url.get('location_country'),
        pub_cityid: url.get('location_cityid'),
        request_params: {
            request_query: config?.params,
            request_body: method?.data instanceof FormData ? objectValue : method?.data
        },
        request_url: requsetUrl
    };
};

export const getRequestTiming = (method: Method) => {
    const timeEnd = window.performance ? window.performance.now() : Date.now();
    const timeStart = method?.meta?.timeStart || '';

    return timeStart ? Math.round(timeEnd - timeStart) : undefined;
};

// 请求发送的埋点
export const requestSendTrack = (method: Method) => {
    const trackData = getCommonTrackData(method);

    trackEvent('pub_marketing_request_send_sw', trackData);
};

// 请求发送成功的埋点
export const requestSuccessTrack = (response: Responce, method: Method, data?: Data) => {
    const trackData = getCommonTrackData(method);

    const params = {
        ...trackData,
        pub_trace: data?.traceId,
        response_status: response.status,
        response_status_text: response.statusText,
        timing: getRequestTiming(method)
    };

    trackEvent('pub_marketing_request_success_sw', params);
};

const extractErrorCode = (str: string) => {
    // 使用正则表达式匹配三位数字
    const regex = /\b\d{3}\b/;
    const matches = str.match(regex);

    // 如果匹配成功，则返回第一个匹配的值
    if (matches) {
        return matches[0];
    }

    return ''; // 没有找到匹配项
};

// 请求发送异常的埋点(服务返回非200)
export const requestHttpErrorTrack = (err: Error, method: Method) => {
    const trackData = getCommonTrackData(method);

    let failType = '';

    if (/timeout/.test(err?.message) || /time out/.test(err?.message)) {
        failType = 'timeout';
    } else if (/NetworkError/i.test(err?.message) || /fail/i.test(err?.message)) {
        failType = 'network_error';
    }

    const params = {
        ...trackData,
        response_status: extractErrorCode(err?.message),
        response_status_text: err?.message,
        timing: getRequestTiming(method),
        fail_type: failType
    };

    trackEvent('pub_marketing_request_error_sw', params);
};

// 请求发送异常的埋点(服务端异常, errorno !== 0)
export const requestServerErrorTrack = (responce: Responce, method: Method, data?: Data) => {
    const trackData = getCommonTrackData(method);

    const params = {
        ...trackData,
        response_errno: data?.errno || data?.errorCode,
        response_msg: data?.errmsg || data?.errorMsg,
        pub_trace: data?.traceId,
        response_status: responce.status,
        response_status_text: responce.statusText,
        timing: getRequestTiming(method)
    };

    trackEvent('pub_marketing_request_error_sw', params);
};

export const requestEndSendTrack = (response: Responce, method: Method, data: { errno?: any; errorCode?: any; errmsg?: any; errorMsg?: any;}) => {
    try {
        if (data) {
            if (data.errno === 0 || data.errorCode === 10000) {
                requestSuccessTrack(response, method, data);
            } else {
                requestServerErrorTrack(response, method, data);
            }
        }
    } catch (e) {
        console.log(e);
    }
};
